import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
import { CompareMetaDataRequestModel, FileDownloadRequestModel, QueryModel, RequestModel, SaveQueryModel, UpdateQueryModel } from "../../types/AdvanceSearchModel";

const advancedSearchUrl = urlConfig.AdvancedSearch; // Get the GetField endpoint from urlConfig
const compareMetaDataUrl = urlConfig.CompareMetaData;
const fileDownloadApiUrl = urlConfig.FileDownloadApi;
const saveQueryUrl = urlConfig.AdvancedSearchSaveQuery;
const getSaveQuery = urlConfig.GetSaveQuery;
const getSavedQueryDetails = urlConfig.GetSavedQueryDetails;
const updateQuery = urlConfig.UpdateQuery;

export const getAdvanceSearchData = async (advanceSearchModel: RequestModel) => {
    try {
        const response = await postCall(advancedSearchUrl, advanceSearchModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred while fetching advanced search data:", error);
        throw error;
    }
};

export const getCompareMetaData = async (advanceSearchModel: CompareMetaDataRequestModel) => {
    try {
        const response = await postCall(compareMetaDataUrl, advanceSearchModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred in Compare Metadata:", error);
        throw error;
    }
};

export const getFileDownload = async (fileDownloadModel: FileDownloadRequestModel) => {
    try {
        const response = await postCall(fileDownloadApiUrl, fileDownloadModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred in FileDownload:", error);
        throw error;
    }
};

export const SaveAdvanceSearchQuer = async (saveQueryModel: SaveQueryModel) => {
    try {
        const response = await postCall(saveQueryUrl, saveQueryModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred while saving AdvanceSearch data:", error);
        throw error;
    }
};

export const GetSavedQuery = async (getQueryModel: QueryModel) => {
    try {
        const response = await postCall(getSaveQuery, getQueryModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred while fetching SavedQuery:", error);
        throw error;
    }
};

export const GetSavedQueryDetails = async (getQueryModel: QueryModel) => {
    try {
        const response = await postCall(getSavedQueryDetails, getQueryModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred while fetching SavedQueryDetails:", error);
        throw error;
    }
};

export const UpdateQuery = async (updateQueryModel: UpdateQueryModel) => {
    try {
        const response = await postCall(updateQuery, updateQueryModel);
        return response.data;
    } catch (error) {
        console.error("Error occurred while Updating Query:", error);
        throw error;
    }
};